// Ventanas horarias de entrega — fuente única de verdad.
// El valor (key) coincide 1:1 con el enum public.ventana_horaria en Supabase.
//
// Si agregás/sacás una franja:
// 1) ALTER TYPE en BD (ver migration agregar_ventana_horaria_noche).
// 2) Actualizá este array.
// 3) Revisá los lugares que usan los helpers (grep por 'ventanasHorarias').

export const VENTANAS_HORARIAS = [
  { key: 'manana', label: 'Mañana 10–14hs',        corto: 'mañana',      hi: '10:00', hf: '14:00', emoji: '🌅' },
  { key: 'tarde',  label: 'Tarde 14–18hs',         corto: 'tarde',       hi: '14:00', hf: '18:00', emoji: '🌇' },
  { key: 'noche',  label: 'Tarde-noche 18–21hs',   corto: 'tarde-noche', hi: '18:00', hf: '21:00', emoji: '🌆' },
]

// Ventanas asignadas por el SISTEMA, no elegibles a mano en selects.
// 'flex' = LimpackFlex: entrega el mismo día 16–21hs (corte 16). La setea crear_pedido_oneshot
// cuando envio_modo='flex'. No va en VENTANAS_HORARIAS para que no aparezca como opción manual.
export const VENTANAS_SISTEMA = [
  { key: 'flex',   label: 'LimpackFlex 16–21hs',   corto: 'flex',        hi: '16:00', hf: '21:00', emoji: '⚡' },
]

// Mapa O(1) por key — incluye las del sistema para que los labels resuelvan en todos lados.
const PORKEY = Object.fromEntries([...VENTANAS_HORARIAS, ...VENTANAS_SISTEMA].map(v => [v.key, v]))

/** Devuelve el label largo de una key. Si la key no existe, devuelve el propio valor. */
export function labelVentana(key) {
  return PORKEY[key]?.label || key || '—'
}

/** "mañana", "tarde", "tarde-noche", "flex" */
export function labelCortoVentana(key) {
  return PORKEY[key]?.corto || key || '—'
}

/** "10:00 - 14:00" */
export function rangoHorarioVentana(key) {
  const v = PORKEY[key]
  return v ? `${v.hi} - ${v.hf}` : '—'
}

/** Para selects nativos: solo las ventanas ELEGIBLES a mano (sin 'flex'). */
export function opcionesVentana() {
  return VENTANAS_HORARIAS.map(v => ({ value: v.key, label: v.label }))
}

/** Orden cronológico — útil para ordenar entregas por franja. 'flex' (16–21) ordena al final. */
export function ordenVentana(key) {
  const todas = [...VENTANAS_HORARIAS, ...VENTANAS_SISTEMA]
  const ix = todas.findIndex(v => v.key === key)
  return ix === -1 ? 999 : ix
}
